<div *ngIf="movement"
    class="d-flex mb-3">

    <div class="flex-1">{{ getMovementText(movement) }}</div>

    <!-- hiding this for now, it's fucking ugly -->
    <!-- <div class="pl-3"
        *ngIf="movement.speedLimit">
        <div class="rounded-circle road-sign-prohibitory">
            {{ movement.speedLimit }}
        </div>
    </div> -->


</div>


<p *ngIf="trip">
  {{ 'STATUS.DETAILS.SUMMARY.STARTED_TRIP_DISTANCE_AGO_AT_TIME_FROM_ADDRESS' | translate: {
        distance: trip.distance | units: 'distance',
        time: trip.dateStart | units: 'time',
        address: trip.addressStart
    }
  }}
</p>
